import * as React from "react";
// import { Link } from 'react-router-dom';
// import { Row } from "reactstrap";

// icons
import "font-awesome/css/font-awesome.min.css";
import loginImage from "../../assets/images/loginbg_no.png";
// styling
import "bootstrap/dist/css/bootstrap.min.css";
import "./loginPage.css";

// toast
import "react-toastify/dist/ReactToastify.css";

// components
import Loader from "react-loader";
import NavBar from "../../components/CustomNav/CustomNav.Component";

// router
import { Redirect } from "react-router-dom";

// toast component
import { toast, ToastContainer } from "react-toastify";

import parentIcon from "../../assets/images/onboard/parent-icon.png";
import schoolIcon from "../../assets/images/onboard/school-icon.png";

import teacherImg from "../../assets/images/login/TEACHER.png";

import msIcon from "../../assets/images/sso/ms-icon.png";

import googleIcon from "../../assets/images/sso/google-icon.png";

import {
  currentBaseUrl,
  isFirstLogIn,
  isUserLoggedIn,
  login,
  isBasicPreassessmentDone,
  currentUser,
  currentProfile,
  currentDesignation,
  currentSubscriptionLevel,
  hasActiveSubscription,
  isUserUpgraded,
  ssoRedirect,
  ssoRedirectGoogle,
} from "../../common/services";

// material ui text fields
import { CSSTransition } from "react-transition-group";
import Modal from "react-awesome-modal";
import { Animated } from "react-animated-css";
import withServices from "src/HOCs/withServices";

import { IconWrapper } from "../Onboard/UserEngagement/UserEngagement.styles";

import { FormContainer } from "../Onboard/Common/Common.styles";

import { InputWrapper } from "../Onboard/Institution/Registration/SchoolRegistration.styles";

import {
  Row,
  Col2,
} from "../Onboard/Parent/Registration/ParentRegistration.styles";

interface IProps {
  services: any;
  history: any;
}

class LoginPage extends React.Component<IProps, any> {
  public state = {
    baseurl: currentBaseUrl(),
    loaded: true,
    password: "",
    toDashboard: false,
    toAdminDash: false,
    toForgot: false,
    toStudentOnboarding: false,
    toParentOnboarding: false,
    toSignup: false,
    toPreassessment: false,
    toParentAssessment: false,
    toSchoolDash: false,
    username: "",
    store: this.context,
    navigate: false,
    destination: "",
    openPasswordModal: false,
    resetSent: false,
    resetEmail: "",
    toTeacherPreassessment: false,
    toTeacherDash: false,
    createModal: false,
  };

  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.goToCreate = this.goToCreate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.sendResetLink = this.sendResetLink.bind(this);
    this.ssoMS = this.ssoMS.bind(this);
  }

  public componentDidMount() {
    if (isUserLoggedIn()) {
      if (
        currentDesignation() === "schools" ||
        currentDesignation() === "teachers" ||
        currentDesignation() === "students"
      ) {
        this.props.history.replace(currentBaseUrl() + "menu");
        return;
      }
      this.props.history.replace(currentBaseUrl() + "home");
    }

    // get username from query params
    const username = new URLSearchParams(window.location.search).get('username');
    if (username) {
      this.setState({ username });
    } else {
      this.setState({ username: '' });
    }
  }

  public goToCreate() {
    this.setState({ toSignup: true });
  }

  public ssoMS() {
    ssoRedirect((text) => this.handleLogin(text));
  }

  public ssoGoogle() {
    ssoRedirectGoogle((text) => this.handleLogin(text));
  }

  public onLogout() {
    console.log("dummy");
  }

  public handleChange = (event) => {
    const valnm = event.currentTarget.dataset.arg;
    this.state[valnm] = event.target.value;
  };

  public openPasswordModal = () => {
    this.setState({ openPasswordModal: true });
  };

  public toggleCreateModal = () => {
    const { createModal } = this.state;
    this.setState({ createModal: !createModal });
  };

  public closeModal = () => {
    this.setState({ openPasswordModal: false });
  };

  public toRegisterUser = (dest) => {
    this.props.history.push(dest);
  };

  public logoClick = () => {
    return;
  };

  public handleLogin(res) {
    if (res.code === 200) {
      this.setState({ loaded: true, baseurl: currentBaseUrl() });

      if (currentDesignation() === "admins") {
        this.setState({ toAdminDash: true });
      }

      if (currentDesignation() === "schools") {
        if (isUserUpgraded()) {
          this.setState({ toSchoolDash: true });
        } else {
          this.props.history.replace("/schools/purchase");
        }
      }

      if (currentDesignation() === "teachers") {
        if (isBasicPreassessmentDone()) {
          this.setState({ toTeacherDash: true });
        } else {
          this.setState({ toTeacherDash: true });
        }
      }

      if (
        isFirstLogIn() &&
        currentBaseUrl() !== "schools" &&
        currentBaseUrl() !== "admins"
      ) {
        if (currentDesignation() === "parents") {
          this.setState({ toParentOnboarding: true });
        }
        if (currentDesignation() === "students") {
          this.setState({ toPreassessment: true });
        }
      } else if (!isFirstLogIn() && !isBasicPreassessmentDone()) {
        if (currentDesignation() === "parents") {
          this.setState({ toDashboard: true });
        }
        if (currentDesignation() === "students") {
          this.setState({ toPreassessment: true });
        }
      }
      // else if (isFirstLogIn() && !isBasicPreassessmentDone()) {
      //   // console.log(currentUser() + " profile details " + JSON.stringify(currentProfile(), null, 4));
      //   // this.setState({toPreassessment: true});
      //   if (currentDesignation() === "parents") {
      //     this.setState({ toParentAssessment: true });
      //   }
      //   if (currentDesignation() === "students") {
      //     this.setState({ toPreassessment: true });
      //   }
      // }
      else if (!isFirstLogIn() && isBasicPreassessmentDone()) {
        if (currentDesignation() === "parents") {
          this.setState({ toDashboard: true });
        }
        if (currentDesignation() === "students") {
          this.props.history.replace(`${currentBaseUrl()}menu`);
        }
      } else if (isBasicPreassessmentDone()) {
        if (currentDesignation() === "parents") {
          this.setState({ toDashboard: true });
        }
        if (currentDesignation() === "students") {
          this.props.history.replace(`${currentBaseUrl()}menu`);
        }
      }

      if (hasActiveSubscription() && isUserUpgraded()) {
        if (currentDesignation() === "parents") {
          this.setState({ toDashboard: true });
        }
        //  if (currentDesignation() === "students") {
        //    this.props.history.replace(`${currentBaseUrl()}menu`);
        //  }
      }
    } else if (res.code === 404) {
      this.setState({ loaded: true });
      toast.error("Login failed, check username or password");
    }
  }

  public handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ loaded: false });

    const user = {
      password: this.state.password,
      username: this.state.username,
    };

    login(user, (text) => this.handleLogin(text));
  };

  public async sendResetLink(e) {
    e.preventDefault();
    const { resetEmail } = this.state;
    const resetRes =
      await this.props.services.adminAPI.requestPasswordResetToken({
        email: resetEmail,
      });
    if (resetRes.ok) {
      this.setState({ resetSent: true });
    } else {
      toast.error("Failed, please use the correct email");
    }
  }

  public renderPasswordResetModal() {
    const confirmContent = (
      <Animated
        style={{ height: "100%" }}
        animationIn="flipInY"
        animationOut="flipOutY"
        animationInDelay={300}
        isVisible={this.state.resetSent}
      >
        <div className="password-reset-wrapper">
          <h1 className="reset-title">Reset Link Sent!</h1>
          <div className="success-icon">
            <i className="fa fa-check" style={{ fontSize: "40px" }} />
          </div>
          <p>Please check your inbox for the reset link</p>
        </div>
      </Animated>
    );
    const resetContent = (
      <form className="password-reset-wrapper">
        <h1 className="reset-title">Password Reset</h1>
        <p>
          If your login was set up by your organisation for Microsoft or Google
          Single Sign-On or to use a username and password please consult your
          organisation to reset your password. <br /> <br /> Otherwise, to reset
          your password, enter the email address you use to sign into
          Performance Learning.
        </p>
        <input
          required={true}
          className="custom-textfield"
          type="email"
          name="reset-email"
          data-arg="resetEmail"
          id="reset-email"
          placeholder="Email Address"
          onChange={this.handleChange}
        />
        <button
          type="submit"
          className="green-button login-button"
          onClick={this.sendResetLink}
        >
          Send Reset Link
        </button>
      </form>
    );
    return (
      <Modal
        visible={this.state.openPasswordModal}
        width="500"
        height="400"
        effect="fadeInUp"
        onClickAway={this.closeModal}
        className="password-modal"
        style={{ backgroundColor: "#00000000" }}
      >
        {this.state.resetSent ? confirmContent : resetContent}
      </Modal>
    );
  }

  public renderCreateModal() {
    return (
      <Modal
        visible={this.state.createModal}
        width="500"
        height="300"
        effect="fadeInUp"
        onClickAway={this.toggleCreateModal}
        className="password-modal"
        style={{ backgroundColor: "#00000000" }}
      >
        <div
          style={{
            backgroundColor: "#1a1a1a",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            height: "100%",
            padding: "1.25em 0 0 0",
          }}
        >
          <p
            style={{
              color: "#fff",
              textAlign: "center",
              fontSize: "20px",
              fontWeight: "bold",
            }}
          >
            First tell us who you are . . .{" "}
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
            }}
          >
            <IconWrapper
              onClick={this.toRegisterUser.bind(this, "register/parent")}
            >
              <div className="icon-wrap">
                <img src={parentIcon} alt="" />
              </div>
              <p className="icon-description">A Parent</p>
            </IconWrapper>
            <IconWrapper
              onClick={this.toRegisterUser.bind(this, "register/school")}
            >
              <div className="icon-wrap">
                <img src={schoolIcon} alt="" />
              </div>
              <p className="icon-description">An Institution</p>
            </IconWrapper>
          </div>
        </div>
      </Modal>
    );
  }

  public render() {
    if (this.state.toDashboard === true) {
      return <Redirect to={this.state.baseurl + "home"} />;
    }
    if (this.state.toSignup === true) {
      return <Redirect to="landingpage" />;
    }
    if (this.state.toStudentOnboarding === true) {
      return <Redirect to={this.state.baseurl + "initprofile"} />;
    }
    if (this.state.toParentOnboarding === true) {
      return <Redirect to={this.state.baseurl + "purchase"} />;
    }
    if (this.state.toPreassessment) {
      return <Redirect to={this.state.baseurl + "preassessmentguide"} />;
    }
    if (this.state.toTeacherPreassessment) {
      return <Redirect to={this.state.baseurl + "menu"} />;
    }
    if (this.state.toParentAssessment) {
      return <Redirect to={this.state.baseurl + "assessmentguide"} />;
    }
    if (this.state.toAdminDash) {
      return <Redirect to={`${this.state.baseurl}home`} />;
    }
    if (this.state.toSchoolDash) {
      return <Redirect to={`${currentBaseUrl()}menu`} />;
    }
    if (this.state.toTeacherDash) {
      return <Redirect to={`${currentBaseUrl()}menu`} />;
    }

    return (
      <div className="addBg">
        <NavBar logoutParent={this.onLogout} onLogoClick={this.logoClick} />
        <ToastContainer />
        {this.renderPasswordResetModal()}
        {this.renderCreateModal()}
        <CSSTransition in={true} appear={true} classNames="fade" timeout={1000}>
          <div className="login-main-cont">
            <div className="login-container">
              <Row
                style={{
                  maxWidth: "400px",
                  boxShadow: "10px 10px 64px #0a0a0a",
                }}
              >
                {/* <Col2
                  style={{
                    border: "1px solid #3ee9f7",
                    borderRight: "none",
                    boxShadow: "0 1px 5px 1px #acff24",
                    backgroundColor: "#1a1a1a",
                    borderRadius: "3px 0 0 3px",
                  }}
                  height="560px"
                  width="60%"
                  mobile={false}
                >
                  <div style={{ width: "100%", height: "100%" }}>
                    <img className="login-img" src={teacherImg} alt="" />
                  </div>
                </Col2> */}
                <Col2
                  style={{
                    border: "1px solid #3ee9f7",
                    boxShadow: "0 1px 5px 1px #acff24",
                    backgroundColor: "#1a1a1a",
                    borderRadius: "0 3px 3px 0",
                    paddingTop: "1em",
                  }}
                  height="560px"
                  width="100%"
                  mobile={true}
                >
                  <FormContainer>
                    <form
                      style={{
                        width: "80%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        height: "70%",
                      }}
                      noValidate={false}
                      onSubmit={this.handleSubmit}
                    >
                      <InputWrapper>
                        <p>Username</p>
                        <input
                          className="custom-textfield"
                          type="text"
                          placeholder={this.state.username.length ? this.state.username : "Enter your username"}
                          onChange={this.handleChange}
                          required={true}
                          data-arg="username"
                        />
                      </InputWrapper>

                      <InputWrapper>
                        <p>Password</p>
                        <input
                          className="custom-textfield"
                          type="password"
                          placeholder="Enter your password"
                          onChange={this.handleChange}
                          required={true}
                          data-arg="password"
                        />
                      </InputWrapper>

                      <Loader loaded={this.state.loaded}>
                        <span
                          className="extra-action"
                          onClick={this.openPasswordModal}
                          style={{ cursor: "pointer" }}
                        >
                          Forgot Password?
                        </span>

                        <button
                          className="green-button login-button"
                          type="submit"
                        >
                          Login
                        </button>
                      </Loader>

                      <p
                        style={{
                          color: "#fff",
                          textAlign: "center",
                          fontWeight: "bold",
                          marginTop: "1em",
                        }}
                      >
                        OR
                      </p>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          color: "#fff",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        <div
                          onClick={this.ssoMS}
                          className="sso-button ms-button"
                        >
                          <img src={msIcon} alt="" className="sso-icon" />
                          Sign in with Microsoft
                        </div>

                        <div
                          onClick={this.ssoGoogle}
                          className="sso-button ms-button"
                        >
                          <img src={googleIcon} alt="" className="sso-icon" />
                          Sign in with Google
                        </div>

                        <span style={{ display: "none" }}>
                          Don't have an account?
                        </span>

                        <span
                          className="extra-action"
                          onClick={this.toggleCreateModal}
                          style={{ cursor: "pointer", display: "none" }}
                        >
                          Sign Up
                        </span>
                      </div>
                      {/* </div> */}
                    </form>
                    {/* </FormWrapper> */}
                  </FormContainer>
                </Col2>
              </Row>
            </div>
          </div>
        </CSSTransition>
      </div>
    );
  }
}

export default withServices(LoginPage);



// WEBPACK FOOTER //
// ./src/pages/Login/loginPage.Component.tsx